import { Link } from "react-router-dom";
import { Phone, MessageSquareText, MapPin } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import {
  COMPANY,
  PHONE_DISPLAY,
  TEL_LINK,
  smsLink,
  waLink,
  DEFAULT_MSG,
  NAV_LINKS,
  CITIES,
} from "@/constants/site";

const Footer = () => (
  <footer className="relative bg-asphalt border-t border-white/10 grain" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-16 grid gap-12 md:grid-cols-4">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3">
          <img src="/logo.webp" alt="Paliway Towing logo" className="h-14 w-14 rounded-full ring-2 ring-emergency/70 object-cover bg-white" />
          <div>
            <p className="font-display text-2xl font-black uppercase text-white leading-none">
              Paliway <span className="text-emergency">Towing</span>
            </p>
            <p className="font-mono text-[10px] tracking-[0.25em] text-zinc-500 uppercase mt-1">Tarrant County, TX</p>
          </div>
        </div>
        <p className="mt-5 max-w-sm text-sm leading-relaxed text-zinc-400">
          Fast, reliable light-duty towing and roadside assistance across Tarrant County. Stranded? Call or text — we roll 24/7.
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <a href={TEL_LINK} data-testid="footer-call-button" className="inline-flex items-center gap-2 bg-emergency px-4 py-2.5 font-display text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-emergency-dark">
            <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
          </a>
          <a href={smsLink(DEFAULT_MSG)} data-testid="footer-sms-button" className="inline-flex items-center gap-2 border border-white/20 px-4 py-2.5 font-display text-sm font-bold uppercase tracking-wider text-white transition-colors hover:border-dispatch hover:text-dispatch">
            <MessageSquareText className="h-4 w-4" /> Text Us
          </a>
          <a href={waLink(DEFAULT_MSG)} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-button" className="inline-flex items-center gap-2 bg-dispatch px-4 py-2.5 font-display text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-dispatch-dark">
            <FaWhatsapp className="h-4 w-4" /> WhatsApp
          </a>
        </div>
      </div>

      <div>
        <p className="font-mono text-xs tracking-[0.25em] text-emergency uppercase mb-5">Quick Links</p>
        <ul className="space-y-3">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-zinc-400 transition-colors hover:text-white">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="font-mono text-xs tracking-[0.25em] text-emergency uppercase mb-5">Service Area</p>
        <ul className="grid grid-cols-1 gap-2">
          {CITIES.slice(0, 7).map((c) => (
            <li key={c} className="flex items-center gap-2 text-sm text-zinc-400">
              <MapPin className="h-3.5 w-3.5 text-dispatch shrink-0" /> {c}
            </li>
          ))}
          <li className="text-xs text-zinc-500 mt-1">+ all of Tarrant County</li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col sm:flex-row items-center justify-between gap-3 px-4 sm:px-6 py-6">
        <p className="font-mono text-[11px] tracking-wider text-zinc-500 uppercase">
          © 2026 {COMPANY} — All rights reserved
        </p>
        <p className="font-mono text-[11px] tracking-wider text-zinc-500 uppercase">
          24/7 Emergency Line: <a href={TEL_LINK} className="text-emergency hover:underline">{PHONE_DISPLAY}</a>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
